import ReferenceDetails from '@/components/ReferenceDetails'
import {
  shouldShowDecisionComments,
  shouldShowReferenceDetails,
} from '@/components/ReferenceDetails/utils'
import type { IncomeAccountantReference } from '@/types/Activity'

import { toReferee, toReferenceDetails } from './utils'

export interface Props {
  applicantName?: string
  accountantReference: IncomeAccountantReference
  navigateToAccountantReferee: (id: string) => void
}

const AccountantReferenceDetails = ({
  applicantName,
  accountantReference,
  navigateToAccountantReferee,
}: Props) => {
  const outcomeStatus = accountantReference.outcome.status
  return (
    <ReferenceDetails
      referee={toReferee(accountantReference)}
      refereeType="accountant"
      applicantName={applicantName}
      referenceDetails={
        shouldShowReferenceDetails(outcomeStatus)
          ? toReferenceDetails(accountantReference)
          : undefined
      }
      decisionComments={
        shouldShowDecisionComments(outcomeStatus)
          ? accountantReference.outcome.comments
          : undefined
      }
      additionalContext={accountantReference.additionalContext ?? undefined}
      navigateToReferee={navigateToAccountantReferee}
    />
  )
}

export default AccountantReferenceDetails
